module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO19QueEsIngreso (50).045aa26.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO19QueEsIngreso (50).mp4
// module id = 745
// module chunks = 1